// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInputLight_container__2_n19","input":"SearchInputLight_input__1krKN"};